<template>
  <div class="lead-qualification-flow">
    <riseup-header/>
    <radio-button-survey v-if="componentType === componentTypes.QUESTION"
                         :totalQuestions="totalQuestions"
                         v-bind="surveyQuestion"
                         @new-survey-question="newQuestion" @next-clicked="nextClicked"/>
    <value-prop-cashflow-goal v-else-if="isRiseupGoalValueProp" :next="nextPage"/>
    <value-prop v-else :component-name="componentName" :next="nextPage"/>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState, mapActions, mapGetters } from 'vuex';
import RadioButtonSurvey from '../../../../../base-components/survey/RadioButtonSurvey.vue';
import ValueProp from './value-props/ValueProp.vue';
import ValuePropCashflowGoal from './value-props/ValuePropCashflowGoal.vue';
import valueProps from './consts/value-props';
import questions from './consts/questions';
import RiseupHeader from '../../../../../base-components/app-header/RiseupHeader.vue';
import Segment from '../../../../../Segment';

export default {
  name: 'LeadQualificationSurvey',
  components: {
    RiseupHeader,
    RiseupButton: BaseUI.RiseupButton,
    RadioButtonSurvey,
    ValueProp,
    ValuePropCashflowGoal,
  },
  props: {
    componentName: {
      type: String,
      required: true,
    },
    componentType: {
      type: String,
      required: true,
    },
  },
  created() {
    this.gotoPage({ componentName: this.componentName, componentType: this.componentType });
  },
  computed: {
    ...mapState('leadQualification', ['componentTypes']),
    ...mapGetters('leadQualification', ['currentQuestion', 'questionIndex']),
    totalQuestions() {
      return questions.QUESTIONS.length;
    },
    surveyQuestion() {
      return { ...this.currentQuestion, index: this.questionIndex };
    },
    isRiseupGoalValueProp() {
      const isCashflowGoal = this.componentName === valueProps.VALUE_PROP_NAMES.CASHFLOW_GOAL;
      return this.componentType === this.componentTypes.VALUE_PROP && isCashflowGoal;
    },
  },
  methods: {
    ...mapActions('leadQualification', ['gotoPage', 'nextPage']),
    newQuestion() {
      const { name: questionName } = this.currentQuestion;
      Segment.trackUserInteraction(`LQQuestion${questionName}Entered`, { questionIndex: this.questionIndex, questionName });
    },
    nextClicked({ answer }) {
      const { name: questionName } = this.currentQuestion;
      Segment.trackUserInteraction(`LQQuestion${questionName}AnswerClicked`, { questionIndex: this.questionIndex, questionName, answer });
      Segment.trackUserInteractionToPixel(`LQ${answer}`);
      this.nextPage({ questionName, answer });
    },
  },
  watch: {
    componentName(componentName) {
      this.gotoPage({ componentName, componentType: this.componentType });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';

.lead-qualification-flow {
  @include white-page-frame;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/LeadQualificationFlow.vue